export default {
  title: 'Espace client',
  titlePrefix: 'à l\'',
  ErrorTitle: 'Erreur technique',
  ErrorMessage: 'Nous sommes désolés des inconvénients que cela peut vous causer.',
  ErrorRetryButton: 'Réessayer',
  NotFoundTitle: 'Page introuvable',
  NotFoundMessage: 'Désolé, la page a été déplacée ou supprimée.',
  NotFoundBackButton: 'Retour',
};
